import { createStore, type GettersObj } from '../../utils/createStore'

export type GettersSnackbar = GettersObj<typeof mapGettersSnackbar>

const DEFAULT_DURATION_MS = 3000
// a new message restarts the countdown: the previous one must not hide it early
let hideTimer: ReturnType<typeof setTimeout> | undefined

export class SnackbarState {
  visible = false
  message = ''
  color = ''
}

export const {
  snackbar,
  commit: commitSnackbar,
  dispatch: dispatchSnackbar,
  mapState: mapStateSnackbar,
  mapGetters: mapGettersSnackbar,
  useGetter: useGetterSnackbar,
  useState: useStateSnackbar,
} = createStore({
  namespaced: true,
  initState: new SnackbarState(),
  getters: {},
  moduleName: 'snackbar',
  actions: {},
  mutations: {
    SHOW(
      state,
      {
        message,
        color,
        durationMs = DEFAULT_DURATION_MS,
      }: { message: string; color: string; durationMs?: number },
    ) {
      state.message = message
      state.color = color
      state.visible = true
      clearTimeout(hideTimer)
      hideTimer = setTimeout(() => {
        state.visible = false
      }, durationMs)
    },
  },
})
